import { useEffect } from 'react';

import { useNavigationStore } from '../../../context/zustand/navigationStore';
import { useSlidesStore } from '../../../context/zustand/slidesStore';
import { usePorteeSlideManager, usePotree } from '../../../hooks/usePotree';
import { useToggle } from '../../../hooks/useToggle';
import { OrtoScene } from '../../../types';
import { AccordionContent, AccordionTrigger } from '../../shadcn-ui/accordion';
import Slide from './Slide';

interface SceneSlidesProps {
  order: string;
  slides: OrtoScene[];
}

const Presentation: React.FC<SceneSlidesProps> = ({
  slides,
  order: presentationOrder,
}) => {
  const { project } = usePotree();
  const potreeSlideManager = usePorteeSlideManager();
  const { potreeDisplayMode } = useToggle();

  const state = useSlidesStore();
  const { activeSlide } = state;

  const keyboardEvents = useNavigationStore((state) => state.keyboardEvents);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const displayModeScenes =
        project?.field_scenes[potreeDisplayMode]?.scenes;

      if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && displayModeScenes) {
        e.preventDefault();

        const currentIndex = displayModeScenes.findIndex(
          (scene) => scene.id === activeSlide.id
        );

        let newIndex;
        if (e.key === 'ArrowUp') {
          newIndex =
            currentIndex === 0
              ? displayModeScenes.length - 1
              : currentIndex - 1;
        } else {
          newIndex =
            currentIndex === displayModeScenes.length - 1
              ? 0
              : currentIndex + 1;
        }

        const targetScene = displayModeScenes[newIndex];
        if (targetScene) {
          potreeSlideManager.goToSlide(targetScene, potreeDisplayMode);
        }
      }
    };

    if (keyboardEvents === 'enabled') {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    activeSlide.id,
    potreeSlideManager,
    potreeDisplayMode,
    project?.field_scenes,
    keyboardEvents,
  ]);

  // NOTE: another hack, this time for backward compatibility of the projects
  // checks if a presentation is really a presentation or not. If not, does not wrap the slides in an accordion.
  const isPresentation =
    slides.filter((slide) => false && slide.label.startsWith('#')).length > 0;

    /*
		changed: nestable
	*/

    //isPresentation = false;

  if (!isPresentation) {
    return (
      <div className="flex flex-col gap-2">
        {slides.map((slide, index) => (
          <Slide
            key={`slide-${presentationOrder}-${index + 1}`}
            slide={slide}
            order={`${index + 1}`}
          />
        ))}
      </div>
    );
  }

  return (
    <>
      {slides.map((slide, index) => {
        if (index === 0) {
          return (
            <AccordionTrigger
              key={`slide-${presentationOrder}-${index}`}
              className="pb-2"
            >
              {/* TODO this should probably become a dedicated PresentationHeader (or so) component at some point */}
              <Slide slide={slide} order={presentationOrder} isParent />
            </AccordionTrigger>
          );
        }
        return (
          <AccordionContent
            key={`slide-${presentationOrder}-${index}`}
            className="pb-2"
          >
            <Slide slide={slide} order={`${presentationOrder}.${index}`} />

        </AccordionContent>
        );
      })}
    </>
  );
};

export default Presentation;
